import "./Arrow.css";

interface Props {
    thickness?: number;
    size?: number;
    backgroundColor?: string;
    rotation?: number;
}

const Arrow: React.FC<Props> = ({ thickness = 1, backgroundColor, rotation = 0, size }) => {
    return (
        <div
            className='alternative-modal-arrow'
            style={{
                ...(size ? { width: `${size}px`, height: `${size}px` } : {}),
                fontSize: `${thickness}px`,
                transform: `rotate(${rotation}deg)`,
            }}
        >
            <div
                className="arrow-body"
                style={{ ...(backgroundColor ? { backgroundColor } : {}) }}
            >
            </div>
        </div>
    )
}

export default Arrow;